import React from "react";
import NavbarFr from "components/NavbarFr";
import FooterFr from "components/FooterFr";
import ProgramCommFr from "components/AboutUs/MembersFr";
import { useSelector } from "react-redux";
import MobileNavbarFr from "components/MobileNavbarFr";
import MobileFooterFr from "components/MobileFooterFr";
import { useEffect } from "react";

function AboutUsFr () {

    const isMobile = useSelector(state => state.windowSize.isMobile);
      
    useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    }, []);

    return(
        <>
        {isMobile ? (
            <>
            <MobileNavbarFr />
            <ProgramCommFr />
            <MobileFooterFr />
            </>
        ) : (
            <>
            <NavbarFr />
            <ProgramCommFr />
            <FooterFr />
        </>
        )}
        </>
    )
};

export default AboutUsFr